import { firestoreAction } from 'vuexfire'
import { db } from '@/firebase/db'
import Cookies from 'js-cookie'
import store from '@/store'

const state = {
  companies: [],
  inspect: null,
  current: null,
  rerender: 0,
  loadingCompany: {
    companyname: 'Velg en bedrift',
    gpcandeclare: false,
    organizationnumber: 123123123
  }
}

const getters = {
  list(state){
    return state.companies
  },

  inspect(state){
    return state.inspect
  },

  id: (state) => (id) => {
    return state.companies.find(item => item.id == id)
  },

  current(state){
    if(typeof state.current === 'undefined')
      return state.loadingCompany
    
    return state.current
  },
  
  rerender(state){
    return state.rerender
  }
}

const mutations = {
  add(state, company){
    state.companies = [...company, ...state.companies]
  },
  current(state, current, rerender = true){ 
    if(typeof current !== 'undefined'){
      Cookies.set('currentCompany', JSON.stringify(current))
      state.current = current
      if(rerender)
        state.rerender++
    }
      
  },

  defaultCurrent(state){
    let currentFromCookie = Cookies.get('currentCompany')
    if(typeof currentFromCookie !== 'undefined'){
      currentFromCookie = JSON.parse(currentFromCookie).organizationnumber
      state.current = state.companies.find(item => item.organizationnumber == currentFromCookie)
    }
    else
      state.current = state.companies[0]
  }
}

const actions = {
  bind: firestoreAction(({ bindFirestoreRef, commit }, userOrganizationnumber) => {
    if(store.getters['user/level'] > 1){
      return bindFirestoreRef('companies', db.collection('companies')).then((company) => {
        if(company.length)
          commit('current', company[0], false)
      })
    }
    else{
      return bindFirestoreRef('companies', db.collection('companies').where('organizationnumber', '==', userOrganizationnumber)).then((company) => {
        if(company.length)
          commit('current', company[0], false)
      })
    }
    
  }),

  inspect: firestoreAction(({ bindFirestoreRef }, id) => {
    return bindFirestoreRef('inspect', db.collection('companies').doc(id))
  }),
  
  all: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('inspect', db.collection('companies')) 
  }),

  current({ commit }, company){
    commit('current', company)
  },
  
  save({ commit}, company){
    if(typeof company.id !== 'undefined'){
      return db.collection('companies').doc(company.id).set(company).then((data) => {
        if(typeof data !== 'undefined'){
          data.get().then(doc => {
            commit('current', doc.data())
            return doc.data()
          })
        }
        else{
          commit('defaultCurrent')
        }
      })
    }
    else{
      return db.collection('companies').add(company)
    }
  }
}


export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}